import { Container } from "@mui/material";
import { useArtist } from "@/services/hooks";
import { useParams } from "react-router-dom";
import ArtistHeader from "@/components/ArtistHeader";
import BottomTabs from "@/components/BottomTabs";
import ExperiencesContainer from "@/components/ExperiencesContainer";
import FeaturedContainer from "@/components/FeaturedContainer";
import MainAppBar from "@/components/MainAppBar";
import MediaContainer from "@/components/MediaContainer";
import MerchContainer from "@/components/MerchContainer";
import MusicContainer from "@/components/MusicContainer";
import NotesContainer from "@/components/NotesContainer";
import PageFooter from "@/components/PageFooter";
import SideTabs from "@/components/SideTabs";
import SubscribeButton from "@/components/SubscribeButton";
import ThreadsContainer from "@/components/ThreadsContainer";
import usePullToRefresh from "@/hooks/usePullToRefresh";
import { SubscribedProvider } from "@/providers/Subscribed";

export default function Subscribe() {
  const { artistKey } = useParams();
  const { data: artist } = useArtist(artistKey);

  usePullToRefresh(() => {
    return window.location.reload();
  });

  return (
    <SubscribedProvider artistKey={artistKey}>
      <Container maxWidth="sm" disableGutters>
        <MainAppBar />
        <ArtistHeader artist={artist} />
        <SubscribeButton artistKey={artistKey} />

        <FeaturedContainer artistKey={artistKey} />
        <NotesContainer artistKey={artistKey} />
        <MusicContainer artistKey={artistKey} />
        <MediaContainer artistKey={artistKey} />
        <ExperiencesContainer artistKey={artistKey} />
        <MerchContainer artistKey={artistKey} />
        <ThreadsContainer artistKey={artistKey} />
        <SideTabs />
        <BottomTabs />
        <PageFooter />
      </Container>
    </SubscribedProvider>
  );
}
